export function splitWithTruncate(value: string, delimiter = ',') {
  const transformedString = value.replace(/ /g, '');
  return transformedString === '' ? [] : transformedString.split(delimiter).filter(Boolean);
}
